import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { AppSettings, DEFAULT_APP_SETTINGS } from '@crowdctrl/shared';

@Injectable({
  providedIn: 'root',
})
export class AppSettingsService {
  private readonly storageKey = 'crowdctrl-app-settings-forms';
  private settingsSubject = new BehaviorSubject<AppSettings>(this.loadSettings());
  settings$ = this.settingsSubject.asObservable();

  getSettings(): AppSettings {
    return this.settingsSubject.value;
  }

  applySettings(settings: AppSettings): void {
    const next = { ...DEFAULT_APP_SETTINGS, ...settings };
    this.settingsSubject.next(next);
    try {
      localStorage.setItem(this.storageKey, JSON.stringify(next));
    } catch (error) {
      console.warn('[AppSettingsService] Failed to persist settings:', error);
    }
  }

  private loadSettings(): AppSettings {
    try {
      const raw = localStorage.getItem(this.storageKey);
      if (!raw) {
        return { ...DEFAULT_APP_SETTINGS };
      }
      const parsed = JSON.parse(raw) as Partial<AppSettings>;
      return { ...DEFAULT_APP_SETTINGS, ...parsed };
    } catch (error) {
      console.warn('[AppSettingsService] Failed to load settings:', error);
      return { ...DEFAULT_APP_SETTINGS };
    }
  }
}
